import { trigger as triggerEvent } from './events';
import { mergeParams, mergeRealParams, registerReadyListener } from './params';
import { getPersonId, getPersonIdBak, getToken } from './util';

let isBeaconLibReady = false;
let isParamsReady = false;

const reportCacheList = [];

const rawReportCacheList = [];

function reportCompass(params) {
  const personId = getPersonId();
  const personIdBak = getPersonIdBak();
  const { protocol, hostname } = location;
  const qua = 'V1_HT5_H5WEISHI_1.0.0_001_IDC_NEW';
  const gTk = hostname.indexOf('qzone.qq.com') >= 0
    || hostname.indexOf('abcmouse.qq.com') >= 0
    || hostname.indexOf('weishi.qq.com') >= 0
    || hostname.indexOf('fm.qq.com') >= 0
    ? getToken()
    : getToken(true);
  const url = `${protocol}//${hostname}/webapp/json/weishi/WSDcReport?personid=${personId}&personidbak=${personIdBak}&qua=${qua}&t=${Math.random()}&g_tk=${gTk}`;

  const xhr = new XMLHttpRequest();
  xhr.open('POST', url);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.send(JSON.stringify({
    data: [
      {
        dataItem: params,
      },
    ],
  }));
  xhr.onerror = function (e) {
    console.log(e);
  };
}

function checkReport() {
  if (isBeaconLibReady && isParamsReady) {
    reportCacheList.forEach((item) => {
      doReport(item.tag, item.params);
    });
    reportCacheList.splice(0, reportCacheList.length);
  } else if (isBeaconLibReady) {
    rawReportCacheList.forEach((item) => {
      rawReport(item.eventName, item.params);
    });
    rawReportCacheList.splice(0, rawReportCacheList.length);
  }
}

registerReadyListener('paramsReady', () => {
  isParamsReady = true;
  checkReport();
});

function doReport(tag, params) {
  mergeParams(tag, params, (eventName, resultParams) => {
    rawReport(eventName, resultParams);
  });
}

export const rawReport = (eventName, resultParams) => {
  const params = {};
  for (const k in resultParams) {
    params[k] = encodeURIComponent(resultParams[k]);
  }
  if (isBeaconLibReady) {
    console.log('window.wsBeaconIns.onDirectUserAction call:', eventName, params);
    window.wsBeaconIns && window.wsBeaconIns.onDirectUserAction(eventName, params);

    triggerEvent('onAfterSend', eventName, params);
    // 这里是做feed trace曝光后台上报，仅对于h5普通视频分享页，后续会去掉这段逻辑，页面代码自己监听onAfterSend
    if (
      location.href.indexOf('/weishi/feed/') !== -1
      && location.href.indexOf('vtype') === -1
    ) {
      reportCompass({ ...params, event_name: eventName });
    }
  } else {
    rawReportCacheList.push({ eventName, params });
  }
};

export const getParams = (tag, params) => {
  const data = mergeRealParams(tag, params);
  return data;
}

export const receiveReport = (tag, params) => {
  console.log(
    'receiveReport isBeaconLibReady:',
    isBeaconLibReady,
    isParamsReady,
  );
  if (isBeaconLibReady && isParamsReady) {
    doReport(tag, params);
  } else {
    reportCacheList.push({ tag, params });
  }
};

export const setReady = () => {
  isBeaconLibReady = true;
  console.log('setReady: isBeaconLibReady');
  checkReport();
};
